import React, { Fragment, Component } from "react";
import WOW from "wowjs";
import { ProDetail } from "./Data";
import Detail3Owl from "./Detail3Owl";
import Header2 from "../../Layout/Header2";
import raceSandtonHeader from "../../../images/race-sandton/header2.jpg";
import raceSandton1 from "../../../images/race-sandton/gallery-1.jpg";
import raceSandton2 from "../../../images/race-sandton/gallery-2.jpg";
import raceSandton3 from "../../../images/race-sandton/gallery-3.jpg";
import raceSandton4 from "../../../images/race-sandton/gallery-4.jpg";
import raceSandton5 from "../../../images/race-sandton/gallery-5.jpg";
import raceSandton6 from "../../../images/race-sandton/gallery-6.jpg";
import raceSandton7 from "../../../images/race-sandton/gallery-7.jpg";
import raceSandton8 from "../../../images/race-sandton/gallery-8.jpg";

const detailBlog = [
  {
    icon: <i className="ti ti-user" />,
    title: "ARCHITECT",
    subtitle: "Tyber Construction",
  },
  {
    icon: <i className="ti ti-location-pin" />,
    title: "LOCATION",
    subtitle: "Sandton, South Africa",
  },
  {
    icon: <i className="ti ti-ruler-alt-2" />,
    title: "SIZE",
    subtitle: "4 500 sqm",
  },
  {
    icon: <i className="ti ti-home" />,
    title: "TYPE",
    subtitle: "Mixed-use automotive and retail",
  },
];

const latestBlog = [
  {
    image: raceSandton1,
  },
  {
    image: raceSandton2,
  },
  {
    image: raceSandton3,
  },
  {
    image: raceSandton4,
  },
  {
    image: raceSandton5,
  },
  {
    image: raceSandton6,
  },
  {
    image: raceSandton7,
  },
  {
    image: raceSandton8,
  },
];
class RaceSandton extends Component {
  componentDidMount() {
    new WOW.WOW().init();
  }
  render() {
    return (
      <Fragment>
        <Header2 />
        <div className="page-content bg-white">
          {/*  banner  */}
          <div
            className="banner-three dlab-bnr-inr"
            style={{
              backgroundImage: `url(${raceSandtonHeader})`,
              backgroundSize: "cover",
              backgroundPosition: "center 45%",
            }}
            data-content="HOME"
            id="sidenav_home"
          ></div>

          <div
            className="section-full content-inner-2 wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.2s"
          >
            <div
              className="container-fluid"
              style={{ maxWidth: "1700px", margin: "auto" }}
            >
              <Detail3Owl latestBlog={latestBlog} />
            </div>
          </div>
          {/*  Info Carousel */}

          {/*  Project Info  */}
          <section className="section-full content-inner">
            <div className="container">
              <div className="section-head">
                <span>DEVELOPED 2015</span>
                <h4 className="title">RACE! Sandton</h4>
              </div>
              <p>
                Located on the prominent corner of Katherine Road and Grayston
                Drive in the heart of Sandton, RACE! Sandton occupies a 7 200
                sqm stand with 4 500 sqm of premium mixed-use automotive and
                retail space.
              </p>

              <p>
                <b>Property Overview</b>
              </p>
              <p>
                RACE! Sandton is a destination designed for automotive
                enthusiasts, luxury brands and discerning customers, bringing
                together world-class motoring, lifestyle and retail experiences
                under one roof.
              </p>
              <p
                style={{
                  listStyleType: "disc",
                  marginLeft: "3%",
                  marginTop: "3%",
                }}
              >
                <b>Automotive Showroom:</b> A modern showroom showcasing
                premium vehicles in an immersive, high-end environment designed
                to elevate the customer experience.
              </p>
              <p
                style={{ listStyleType: "disc", marginLeft: "3%" }}
                className="m-b30"
              >
                <b>Workshop Facilities:</b> State-of-the-art service and
                workshop facilities equipped to deliver expert maintenance,
                repairs and vehicle care.
              </p>
              <p
                style={{ listStyleType: "disc", marginLeft: "3%" }}
                className="m-b30"
              >
                <b>Advanced Detailing and Wrapping Centre:</b> A specialised
                facility offering professional vehicle detailing, paint
                protection, wrapping and customisation services.
              </p>
              <p
                style={{ listStyleType: "disc", marginLeft: "3%" }}
                className="m-b30"
              >
                <b>Ducati South Africa:</b> Home to the Ducati South Africa
                store and workshop, providing enthusiasts with access to the
                latest motorcycles, accessories, servicing and expert support.
              </p>
              <p
                style={{ listStyleType: "disc", marginLeft: "3%" }}
                className="m-b30"
              >
                <b>Corsa Café:</b> A luxury café offering a refined social
                space where visitors can relax, meet and enjoy a premium
                hospitality experience.
              </p>
              <p
                style={{ listStyleType: "disc", marginLeft: "3%" }}
                className="m-b30"
              >
                <b>Luxury Retail Storefronts:</b> Curated retail spaces
                designed for premium brands, creating a vibrant destination
                that blends automotive culture with luxury lifestyle offerings.
              </p>

              <p>
                <b>Location and Accessibility</b>
              </p>

              <p>
                Strategically positioned in Sandton's premier commercial
                district, RACE! Sandton enjoys exceptional visibility and
                accessibility. Its central location provides convenient access
                to major transport routes, leading business hubs and affluent
                residential neighbourhoods, making it a landmark destination
                within Johannesburg's most prestigious precinct.
              </p>

              <div className="row m-b30 widget widget_getintuch widget_getintuch-pro-details pro-details-col-5 m-lr0">
                <ProDetail detailBlog={detailBlog} />
              </div>
            </div>
          </section>
          {/*  Project Info  End*/}
        </div>
      </Fragment>
    );
  }
}

export default RaceSandton;
